export default __webpack_public_path__ + "static/media/granville27.240d1d84.jpg";